import {
  type ThemeContent,
  type StyleSheet,
} from '../../../providers/ThemeProvider';

export default (theme: ThemeContent): StyleSheet => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: '2%',
  },
  top: {
    marginTop: '4vmin',
  },
  addSensorContainer: {
    flex: 2,
  },
  currentSensorsContainer: {
    flex: 3,
  },
  betweenInput: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    gap: 10,
  },
  removeBtn: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '0.875rem',
    fontWeight: '500',
    cursor: 'pointer',
    padding: '0.375rem 0.75rem',
    border: 'solid',
    borderRadius: '0.375rem',
    backgroundColor: theme.colors.primary,
    color: theme.colors.white,
    marginLeft: '0.25rem',
    marginRight: '0.25rem',
  },
  exportBtn: {
    backgroundColor: theme.colors.transparentWhite,
    borderRadius: 5,
    height: '100%',
    borderStyle: 'solid',
  },
  underTitleContainer: {
    marginTop: 20,
  },
  titleText: {
    fontWeight: 'bold',
    fontSize: 24,
  },
  buttonContainer: {
    display: 'flex',
    gap: 10,
    marginTop: 20,
    width: '100%',
  },
});
